/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */

import CloseIcon from "@mui/icons-material/Close";
import { InputProps, SxProps, Theme } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import { debounce } from "lodash";
import * as React from "react";
import { useTranslation } from "react-i18next";
export default function DebouncedTextInput({
  value,
  onChange,
  sx,
  placeholder,
  fullWidth,
  variant,
  label,
  size,
  delay,
  error,
  helperText,
  InputProps,
  focused,
}: {
  value: string;
  onChange: (changed: string) => void;
  sx?: SxProps<Theme>;
  placeholder?: string;
  fullWidth?: boolean;
  variant?: any;
  label?: string;
  size?: any;
  delay?: number;
  error?: boolean;
  helperText?: string;
  InputProps?: InputProps;
  focused?: boolean;
}) {
  const { t } = useTranslation();
  const [inputKey, setInputKey] = React.useState(0);

  const debouncedSearch = debounce(onChange, delay || 500);

  return (
    <TextField
      sx={sx}
      focused={focused}
      label={label}
      variant={variant}
      fullWidth={fullWidth}
      key={inputKey}
      value={undefined}
      onChange={(e) => debouncedSearch(e.target.value)}
      placeholder={placeholder || t("Search...")}
      size={size || "small"}
      error={error}
      helperText={helperText}
      InputProps={{
        ...InputProps,
        endAdornment: (
          <InputAdornment position="end">
            {value ? (
              <IconButton
                size="small"
                onClick={() => {
                  onChange("");
                  setInputKey(inputKey + 1);
                }}
              >
                <CloseIcon />
              </IconButton>
            ) : null}
          </InputAdornment>
        ),
      }}
    />
  );
}
